import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordion: {
      border: 'none !important',
    },
    card: {
      width: 640,
      margin: theme.spacing(8, 'auto', 0),
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    cardContainer: {
      margin: theme.spacing(0, 'auto'),
      padding: theme.spacing(8, 10),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(8, 4),
      },
    },
    expandedSummary: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    footer: {
      borderColor: theme.palette.divider,
      borderTop: 'solid 1px',
      padding: theme.spacing(3),
    },
    header: {
      marginBottom: theme.spacing(2),
    },
    phoneNumberText: {
      whiteSpace: 'nowrap',
    },
    policy: {
      margin: theme.spacing(3, 4, 10),
      maxWidth: 560,
    },
    resetButton: {
      fontSize: 13,
    },
    summaryIcon: {
      fontSize: '0.9rem',
      '&:hover': {
        color: theme.palette.grey[450],
      },
    },
    title: {
      paddingBottom: theme.spacing(1.5),
    },
    dialogTitle: {
      margin: 0,
      padding: theme.spacing(0, 3),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    dialogContent: {
      width: `${theme.spacing(71)} !important`,
      height: `${theme.spacing(50)} !important`,
      padding: theme.spacing(4, 4, 0),
      alignItems: 'center',
    },
    buttonContainer: {
      paddingTop: theme.spacing(5),
      paddingRight: theme.spacing(4),
      textAlign: 'right',
    },
    link: {
      cursor: 'pointer',
    },
    extoleBlock: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 10,
      gap: 8,
    },
    extoleText: {
      order: 0,
      flexGrow: 0,
      bottom: '16.67%',
      '& a': {
        fontStyle: 'normal',
        fontSize: 16,
        lineHeight: '16px',
        textAlign: 'right',
        color: '#05A0D9',
        flex: 'none',
        order: 1,
        flexGrow: 0,
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  })
);
